export default __webpack_public_path__ + "media/images/logo-symbol-icon-50ff266219026ce1cc9c3499ddc415e2.svg";